/* eslint-disable no-unused-vars */
/* global G, PLATFORM */
import { asyncPipeSpread, asyncPipeSpreadIf, setKey } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { empty } from 'lib/util/object'
import initDocumentation from 'app/_shared/action/partial/feedback/initDocumentation'
import { displayFavoriteButtonsFromArgs } from 'app/_shared/action/partial/favorite/display'

/**
 * Grabs information about the PDF from the incoming args and maps them to the
 * component's state.
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(*, ...[*]): Promise<*>}
 */
const setAttachment = module => component => async (components, ...args) => {
  const [{ value: { attachment = null, documentationId, ...restArgs } = {} } = {}] = args || []

  const { file } = components

  // Skip this, if we have no incoming values to set
  if (!attachment && empty(restArgs)) {
    return [components, ...args]
  }

  if (attachment?.value?.url || attachment?.value?.name) {
    setKey(!documentationId
      ? attachment
      : { ...attachment, documentationId, term: restArgs?.term },
    'attachment',
    file[G.STATE])
  }

  setKey(restArgs?.page || null, 'page', file[G.STATE])
  setKey(restArgs?.term || null, 'term', file[G.STATE])
  setKey(restArgs?.url || null, 'url', file[G.STATE])

  return [components, ...args]
}

/**
 * EquipmentInformation Attachment With Feedback Action
 *
 * NOTE: We don't use {@link logAccess} here (as opposed to `equipment` and `part` action)
 * because for attachments, it's handled by {@link AttachmentBig}.
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  setAttachment(module)(component),
  asyncPipeSpreadIf(() => PLATFORM === 'mobile')(
    displayFavoriteButtonsFromArgs(module),
  ),
  initDocumentation(module)(component),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
